// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".address-suggest-list[data-v-7dab5eaa],.history-list[data-v-7dab5eaa] .history-col,.suggest-list[data-v-7dab5eaa] .suggest-col{padding-right:20px;padding-left:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
